module.exports = __webpack_public_path__ + "img/E4.550488cc.svg";